<template>
<div>
  <h2 class="mb-4">月間園児予定</h2>
  <attendance-schedule-container />
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import AttendanceScheduleContainer from '@/containers/work-schedule/AttendanceScheduleContainer.vue'

export default defineComponent({
  components: {
    AttendanceScheduleContainer,
},
})

</script>
